module.exports = __webpack_public_path__ + "img/disperse-icon-05.4b1be236.png";